import { Compass, Storefront, Receipt, UserCircle } from '@phosphor-icons/react';
import { motion } from 'framer-motion';
import { NavLink, useLocation } from 'react-router-dom';

import { haptics } from '@shared/lib/telegram';
import styles from './BottomNavBar.module.css';

const TABS = [
  { to: '/', label: 'Store', icon: Storefront },
  { to: '/discover', label: 'Discover', icon: Compass },
  { to: '/orders', label: 'Orders', icon: Receipt },
  { to: '/account', label: 'Account', icon: UserCircle },
] as const;

export function BottomNavBar() {
  const { pathname } = useLocation();
  const tabs = TABS;

  return (
    <nav aria-label="Main navigation" className={styles.nav} data-tabs={tabs.length}>
      {tabs.map((tab) => {
        // A detail route under /panel should keep the Panel tab lit.
        const active = tab.to === '/' ? pathname === '/' : pathname.startsWith(tab.to);
        const Icon = tab.icon;

        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={styles.tab}
            onClick={() => {
              if (!active) haptics.select();
              window.scrollTo({ top: 0, behavior: 'auto' });
            }}
          >
            {/* The pill slides between tabs instead of fading in place. */}
            {active ? (
              <motion.span
                layoutId="nav-pill"
                className={styles.pill}
                transition={{ type: 'spring', stiffness: 380, damping: 30 }}
              />
            ) : null}
            <span className={active ? styles.contentActive : styles.content}>
              <span className={styles.iconWrap}>
                <Icon size={22} weight={active ? 'fill' : 'regular'} />

              </span>
              <span className={styles.label}>{tab.label}</span>
            </span>
          </NavLink>
        );
      })}
    </nav>
  );
}
